// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"ResetPassword_sub-title__2fAfA","errorMessage":"ResetPassword_errorMessage__1RXxV","return-login":"ResetPassword_return-login__2qDAG"};